import React from 'react';
import { Checkbox, FormControl, FormLabel } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { Row } from './helpers';
import { useTranslation } from 'react-i18next';
import { Td, Tr } from './factory';

interface TableRowProps {
  row: Row;
  columnOrder: string[];
  selected?: boolean;
  onSelect?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPreview?: (component: React.ElementType<any>, props: Record<string, string> | undefined) => void;
}

export const TableRow: React.FC<TableRowProps> = ({ row, columnOrder, selected, onSelect, onPreview }) => {
  const { t } = useTranslation();

  return (
    <Tr>
      {columnOrder.map((colName) => {
        const cell = row[colName];
        const handlePreview = (e: React.MouseEvent<HTMLAnchorElement>) => {
          e.preventDefault();
          if (onPreview && cell.previewComponent) onPreview(cell.previewComponent, cell.previewProps);
        };

        if (colName === 'checkboxId') {
          return (
            <Td key={colName}>
              <FormControl>
                <FormLabel hidden>{t('table.selectRow')}</FormLabel>
                <Checkbox id={`checkbox-${row.checkboxId}`} isChecked={selected} onChange={(e) => onSelect?.(e)} />
              </FormControl>
            </Td>
          );
        }

        if (cell.path) {
          return (
            <Td key={colName}>
              <Link to={cell.path}>{cell.data}</Link>
            </Td>
          );
        }

        if (cell.previewComponent) {
          return (
            <Td key={colName}>
              <a href="#" onClick={handlePreview}>
                {cell.data}
              </a>
            </Td>
          );
        }

        return <Td key={colName}>{cell.data}</Td>;
      })}
    </Tr>
  );
};
